import { Accordion, Card, Stack, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { ConflictsList } from './ConflictsList';
import { getConflicts } from './getConflicts';

interface ExistingConflictAccordionProps {
    rule: NonNullable<ReturnType<typeof getConflicts>>['conflictingExistingRules'][number];
    expanded: boolean;
    onAccordionClick: (ruleId: string) => void;
}

export const ExistingConflictAccordion = ({ rule, expanded, onAccordionClick }: ExistingConflictAccordionProps) => (
    <Card padding="100" key={rule.id}>
        <Accordion
            expanded={expanded}
            withBodyBorder={false}
            withHeaderBorder={false}
            onClick={() => onAccordionClick(rule.id)}
            title={
                <Typography textStyle="bodyMediumStrong" as="div">
                    {rule.name}
                </Typography>
            }
            body={
                <Stack vertical spacing="200">
                    <ConflictsList
                        title={lt(TextKey.RoutingRulesFormConflictsServicesInConflict)}
                        entities={rule.services}
                        dataTestId={DataTestId.RoutingRulesExistingConflictsServices}
                    />
                    <ConflictsList
                        title={lt(TextKey.RoutingRulesFormConflictsCompaniesInConflict)}
                        entities={rule.companies}
                        dataTestId={DataTestId.RoutingRulesExistingConflictsCompanies}
                    />
                    <ConflictsList
                        title={lt(TextKey.RoutingRulesFormConflictsTravelAgenciesInConflict)}
                        entities={rule.travelAgencies}
                        dataTestId={DataTestId.RoutingRulesExistingConflictsTravelAgencies}
                    />
                    {rule.rates.map((rate) => (
                        <ConflictsList
                            key={rate.service.id}
                            title={
                                <>
                                    {lt(TextKey.RoutingRulesFormConflictsRatesInConflict)}
                                    {UnicodeEntity.NoBreakSpace}
                                    {UnicodeEntity.Dash}
                                    {UnicodeEntity.NoBreakSpace}
                                    {rate.service.name}
                                </>
                            }
                            entities={rate.rates ?? []}
                            dataTestId={`${DataTestId.RoutingRulesExistingConflictsRates}-${rate.service.name}`}
                        />
                    ))}
                    {rule.prepayment && (
                        <Typography textStyle="bodyMediumStrong" as="div">
                            {lt(TextKey.RoutingRulesFormConflictsPrepaidLabel)}
                        </Typography>
                    )}
                </Stack>
            }
        />
    </Card>
);
